import React, { useState, useCallback, createContext, useContext } from 'react';
import './CustomToast.css';

const ToastContext = createContext();

export const useCustomToast = () => {
    const context = useContext(ToastContext);
    if (!context) {
        throw new Error('useCustomToast must be used within a CustomToastProvider');
    }
    return context;
};

let showToastGlobal = null;

export const CustomToastProvider = ({ children }) => {
    const [toasts, setToasts] = useState([]);

    const showToast = useCallback((message, type = 'success', duration = 1500) => {
        const id = Math.random().toString(36).substr(2, 9);
        setToasts((prev) => [...prev, { id, message, type, duration }]);

        setTimeout(() => {
            setToasts((prev) => prev.filter((toast) => toast.id !== id));
        }, duration);
    }, []);

    const removeToast = (id) => {
        setToasts((prev) => prev.filter((toast) => toast.id !== id));
    };

    // Store the function globally so non-component files can use it
    showToastGlobal = showToast;

    return (
        <ToastContext.Provider value={{ showToast }}>
            {children}
            <div className="custom-toast-container">
                {toasts.map((toast) => (
                    <div
                        key={toast.id}
                        className={`custom-toast ${toast.type}`}
                        style={{ '--duration': `${toast.duration}ms` }}
                    >
                        <div className="toast-icon">
                            {toast.type === 'success' && <i className="bi bi-check-lg"></i>}
                            {toast.type === 'error' && <i className="bi bi-x-lg"></i>}
                            {toast.type === 'info' && <i className="bi bi-info-lg"></i>}
                        </div>
                        <div className="toast-content">
                            <p>{toast.message}</p>
                        </div>
                        <button className="toast-close-btn" onClick={() => removeToast(toast.id)}>
                            <i className="bi bi-x"></i>
                        </button>
                        <div className="toast-progress"></div>
                    </div>
                ))}
            </div>
        </ToastContext.Provider>
    );
};

// Standard object for non-React files
export const toast = {
    success: (msg, dur) => showToastGlobal?.(msg, 'success', dur),
    error: (msg, dur) => showToastGlobal?.(msg, 'error', dur),
    info: (msg, dur) => showToastGlobal?.(msg, 'info', dur),
    show: (msg, dur) => showToastGlobal?.(msg, 'success', dur),
};

